import {
  Card,
  type CardProps,
  Divider,
  Stack,
  Typography,
  styled,
} from "@mui/material"
import { ROLES, SafeApiComponent, useRoleCheck } from "@pharmupp/p3-front-commons"
import { AGENDA_EVENT_HEIGHT, AgendaEvent } from "../../AgendaEvent"
import { AgendaListEventsLink } from "../../AgendaListEventsLink"
import { useAgendaApi } from "../../AgendaV1"

export type MyAgendaProps = {
  viewOneLink: string
  viewAllLink: string
  adherentId?: string
} & Omit<CardProps<typeof Stack>, "component">

export const MyAgendaV1 = ({
  viewOneLink,
  viewAllLink,
  adherentId,
  ...otherProps
}: MyAgendaProps) => {
  const isAdherent = useRoleCheck(ROLES.ADHERENT_HOLDER)

  return (
    <Card p={3} spacing={3} {...otherProps} component={Stack}>
      <Title>Mon agenda</Title>

      <SafeApiComponent
        suspense={{ skeletonProps: { height: AGENDA_EVENT_HEIGHT } }}
      >
        <MyAgendaEvents
          viewOneLink={viewOneLink}
          adherentId={adherentId}
          isAdherent={!!isAdherent}
        />
      </SafeApiComponent>

      {!!isAdherent && (
        <>
          <Divider />
          <AgendaListEventsLink to={viewAllLink} />
        </>
      )}
    </Card>
  )
}

const MyAgendaEvents = ({
  viewOneLink,
  adherentId,
  isAdherent,
}: {
  viewOneLink: string
  adherentId?: string
  isAdherent: boolean
}) => {
  const { events } = useAgendaApi(adherentId)

  return (
    <Stack spacing={2} divider={<Divider />}>
      {events.length > 0 ? (
        events.map((event) => (
          <AgendaEvent
            {...event}
            link={isAdherent ? `${viewOneLink}/${event.id}` : undefined}
            key={event.id}
          />
        ))
      ) : (
        <Typography color="grey.light">Aucun évènement</Typography>
      )}
    </Stack>
  )
}

const Title = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(16),
  fontWeight: 600,
  textTransform: "uppercase",
  color: theme.palette.grey.dark,
}))
